import { NuxtApp } from "#app";

export default defineNuxtPlugin(async (nuxtApp) => {
  await (nuxtApp as NuxtApp).$store.dispatch("nuxtClientInit", nuxtApp);
});
